import React from 'react';
import BannerWithText from '../BannerWithText';
import SalePageProductCards from '../SalePageProductCards';

const SalePage = ({ block }) => {
  const renderSalePageSlices = (type) => {
    switch (type) {
      case 'sale_page_top_banner':
        return <BannerWithText block={block} />;
      case 'sale_page_cards':
        return <SalePageProductCards block={block} />;
    }
  };

  return (
    <>
      <div className="slices-wrapper">
        {renderSalePageSlices(block.slice_type)}
      </div>
      <style jsx>{`
        .slices-wrapper {
          width: 100%;
          display: flex;
          flex-direction: column;
        }
      `}</style>
    </>
  );
};

export default SalePage;
